import { AnnotationTextInput } from "./AnnotationTextInput";
import { useState } from "react";
import type { Annotation } from "../api/types";
import { formatTimecode } from "../player/time";
import { currentActivity } from "../player/activityLabels";

/** Two reserved rows keep the player and timeline stationary during playback. */
export function FrameLabels({annotations, time, onPause, onSelect, onUpdate, onAdd}: {
  annotations: Annotation[]; time: number; selectedId: string | null;
  onPause: () => void; onSelect: (id: string) => void;
  onUpdate: (id: string, patch: Partial<Annotation>) => Promise<void>;
  onAdd: (label: string, level: "context" | "activity") => Promise<void>;
}) {
  const [adding,setAdding] = useState(false);
  const [draft, setDraft] = useState("");
  const [level, setLevel] = useState<"context" | "activity">("activity");
  const [error, setError] = useState("");
  return <section className="panel pad frame-labels" aria-label="Activity chapters">
    <div className="row"><strong title="AI proposals require human review">Activity chapters</strong><button className="ghost tiny" onClick={()=>{onPause();setAdding(v=>!v);}}>{adding ? "Cancel" : "+ Label"}</button><span className="spacer"/><span className="tiny muted mono">{formatTimecode(time)}</span></div>
    <div className="activity-rows">
      {(["context", "activity"] as const).map(tier => {
        const a = currentActivity(annotations,time,tier);
        return <div className="activity-row" key={tier}>
          <span className="tiny muted">{tier === "context" ? "Context" : "Activity"}</span>
          {a ? <>
            <AnnotationTextInput aria-label={`${tier} label`} value={a.label} key={a.id}
              onFocus={()=>{onPause();onSelect(a.id);}} onCommit={label => onUpdate(a.id,{label})} />
            <span className="tiny muted activity-range">{formatTimecode(a.start_ns)}–{formatTimecode(a.end_ns??a.start_ns)}</span>
            <button className="ghost tiny" title="Edit interval in inspector" onClick={()=>{onPause();onSelect(a.id);}}>Edit</button>
          </> : <span className="tiny muted">{tier === "context" ? "No context chapter yet" : "No sustained activity identified"}</span>}
        </div>;
      })}
    </div>
    {adding && <form className="activity-add" onSubmit={async e=>{e.preventDefault();if(!draft.trim())return;try{await onAdd(draft.trim(),level);setDraft("");setError("");setAdding(false);}catch(e){setError((e as Error).message);}}}>
      <select aria-label="Chapter level" value={level} onChange={e=>setLevel(e.target.value as typeof level)}><option value="context">Context</option><option value="activity">Activity</option></select>
      <input aria-label="New activity label" placeholder="Describe the task…" value={draft} onFocus={onPause} onChange={e=>setDraft(e.target.value)}/>
      <button type="submit" disabled={!draft.trim()}>Add</button>
    </form>}
    {error && <div className="tiny activity-message" role="alert">{error}</div>}
  </section>;
}
